module.exports = __webpack_public_path__ + "media/images/vector-97@2x-3964d3da0a80d27948376bdbd88ab21d.png";